import { Observable } from 'rxjs';
import { OrderedMap } from 'immutable';

import { apolloClient } from 'entities/graphql';
import { updateVolunteerProperty } from 'entities/volunteers/actions';
import { addMultipleAction } from 'entities/volunteerTimeOff/actions';
import { VolunteerTimeOffsListDocument, VolunteerTimeOffSummaryDocument } from 'generated/graphql';

import VolunteerTimeOff from './model';

export default class VolunteerTimeOffApi {
  public static fetchVolunteerTimeOffs(id: string): Observable<object> {
    return Observable.from(
      apolloClient.query({
        query: VolunteerTimeOffsListDocument,
        variables: {
          volunteerTimeOffsUserId: id,
        },
      })
    ).map(({ data: volunteerTimeOffsData }) =>
      addMultipleAction(
        OrderedMap(
          volunteerTimeOffsData.volunteerTimeOffs.map((vto) => [
            vto.id,
            new VolunteerTimeOff({ user: vto.userId, ...vto }),
          ])
        )
      )
    );
  }

  public static fetchVolunteerTimeOffSummary(id: string): Observable<object> {
    return Observable.from(
      apolloClient.query({
        query: VolunteerTimeOffSummaryDocument,
        variables: {
          volunteerTimeOffSummaryUserId: id,
        },
      })
    ).map((res) =>
      updateVolunteerProperty(id, 'volunteerTimeOffSummary', res.data.volunteerTimeOffSummary)
    );
  }
}
